import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { logoutAsync } from './auth';
import { useRouteMatch } from 'react-router-dom';

export const useLogoutHook = (): any => {
  const dispatch = useDispatch();
  const handleLogout = useCallback(() => {
    dispatch(logoutAsync());
  }, [dispatch]);

  return [handleLogout];
};

export const useLogDate = (): [string] => {
  const routeMatch = useRouteMatch<{ date: string }>();
  return [routeMatch.params.date];
};
